var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "88.000000pt",
    viewBox: "0 0 88.000000 88.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
    fill: "#9c9c9c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338 865 c-29 -9 -48 -22 -48 -30 0 -18 -2 -18 50 0 102 36 239 8 323 -65 44 -39 67 -49 67 -31 0 18 -84 84 -139 109 -69 32 -182 39 -253 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 776 c-26 -27 -40 -49 -36 -56 5 -8 23 4 56 36 27 27 49 52 49 56 0 20 -29 4 -69 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 796 c-28 -14 -69 -43 -91 -65 -42 -43 -85 -118 -76 -133 10 -16 20 -7 38 33 52 117 190 186 320 159 84 -17 157 -75 197 -156 18 -35 36 -67 41 -70 22 -14 19 11 -8 67 -35 75 -114 150 -180 173 -73 25 -178 21 -241 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 754 c-99 -35 -168 -133 -169 -239 -1 -60 27 -155 45 -155 13 0 11 14 -7 77 -60 207 139 371 332 273 69 -35 64 -33 64 -17 0 14 -46 45 -95 64 -41 16 -121 14 -170 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 693 c-81 -42 -122 -116 -112 -208 6 -58 78 -212 104 -222 24 -9 26 5 4 36 -12 16 -35 59 -52 96 -27 56 -31 75 -27 126 3 38 11 69 25 87 19 26 70 65 96 75 8 3 9 8 2 15 -7 7 -19 6 -40 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 700 c0 -5 6 -10 13 -10 30 0 89 -23 114 -44 16 -13 45 -57 65 -97 38 -75 120 -169 132 -151 4 6 -15 34 -40 63 -26 29 -56 73 -67 98 -28 67 -63 108 -107 131 -41 21 -110 27 -110 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 646 c-43 -19 -82 -68 -90 -114 -8 -48 20 -125 76 -212 41 -64 135 -170 150 -170 20 0 6 29 -32 65 -55 53 -133 173 -154 236 -23 67 -14 109 31 148 27 24 44 31 78 31 54 0 88 -25 121 -91 14 -27 30 -49 35 -49 14 0 12 12 -9 61 -42 93 -124 131 -206 95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638 655 c-8 -9 60 -137 87 -164 34 -35 43 -18 12 23 -14 18 -37 59 -51 90 -23 52 -35 64 -48 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 569 c-19 -23 -25 -41 -23 -66 3 -38 22 -46 26 -11 6 54 14 69 39 79 46 17 74 -3 112 -83 25 -55 54 -92 116 -155 78 -77 105 -96 105 -74 0 5 -37 47 -83 93 -57 57 -92 102 -112 143 -41 87 -60 105 -111 105 -35 0 -47 -5 -69 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 563 c-13 -13 -5 -103 14 -164 35 -113 182 -330 206 -306 9 9 8 10 -59 93 -26 33 -66 97 -89 143 -34 69 -42 96 -46 157 -4 71 -11 91 -26 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 534 c-19 -19 -15 -36 32 -126 52 -100 248 -290 267 -259 3 5 -25 34 -63 66 -85 71 -155 153 -192 227 -32 63 -35 78 -16 78 6 0 20 -21 31 -46 23 -57 103 -164 122 -164 21 0 18 7 -30 68 -25 32 -55 80 -67 107 -30 68 -52 81 -84 49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 461 c-9 -13 110 -141 131 -141 24 0 14 14 -56 84 -42 42 -71 64 -75 57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 422 c0 -25 63 -118 118 -176 58 -59 160 -146 173 -146 21 0 7 26 -26 49 -55 37 -189 182 -221 239 -30 54 -44 65 -44 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 329 c0 -6 21 -43 47 -83 73 -109 243 -271 243 -230 0 3 -40 45 -89 92 -49 48 -110 120 -135 160 -44 67 -66 88 -66 61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 310 c-7 -12 42 -105 88 -165 40 -52 109 -125 119 -125 19 0 4 27 -48 82 -30 33 -76 96 -101 139 -25 44 -47 79 -49 79 -1 0 -6 -5 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 289 c-4 -5 -5 -12 -4 -14 65 -61 119 -91 119 -67 0 15 -109 92 -115 81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 229 c-7 -10 131 -153 179 -184 61 -40 33 1 -65 95 -57 55 -105 100 -106 100 -1 0 -5 -5 -8 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 161 c0 -13 70 -101 80 -101 17 0 11 19 -22 64 -30 41 -58 59 -58 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 128 c1 -21 72 -70 84 -58 5 5 8 11 5 13 -2 2 -19 15 -37 30 -37 29 -52 34 -52 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 63 c0 -10 52 -63 62 -63 16 0 8 27 -15 48 -23 21 -47 29 -47 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerPrint);
export default __webpack_public_path__ + "static/media/finger-print.e205ffa76c47362aa34b455b1a396832.svg";
export { ForwardRef as ReactComponent };